import React, { useEffect } from 'react';
import ReactGA from 'react-ga4';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';

const TRACKING_ID = "G-Z00FZK8PTJ"; // Replace with your GA4 Measurement ID
ReactGA.initialize(TRACKING_ID);

const Analytics = () => {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({ 
      hitType: "pageview", // Not needed in GA4
      event: "page_view", 
      page: location.pathname
    });
  }, [location]);

  return null;
};

export default Analytics;
